module.exports = {
  title: 'Toast Manager with Reanimated and Gesture Handler 🍞',
  author: 'Enzo Manuel Mangano',
  date: '2023-11-22',
  slug: 'toast',
  tags: ['reanimated', 'gesture-handler'],
};
